export default __webpack_public_path__ + "static/media/panorama.609dc8ab.jpg";